// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class EntitlmentDocument {
    constructor(id, name, content) {
        this.Id = id;
        this.Name = name;
        this.Content = content;
    }
}
